import JSEncrypt from 'jsencrypt'

const publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCU0nPbqGSFuK2USGZg95kII73pPUznhOsPzQHVM7ywfamWN4qbH80yRCTwZS0lIkDCIqqNylLlaC+Hezul5bILK+12VZKXSpDdtbBXprCvTZeeZdX90+jTjU0EObVIpYEykzx/iXam5YyRKVyJDav4UTLKQfW7tqwWg2g8LV+YewIDAQAB";
const encrypt = new JSEncrypt();
encrypt.setPublicKey(publicKey);

export default data=>{
  return encrypt.encrypt(data);
}